import React from "react";
import { Router, Link, withSiteData } from "react-static";
import { hot } from "react-hot-loader";
import styled from "styled-components";

import Dropdown from "components/dropdown.js";

const Menustyle = styled.div`
  @media (max-width: 900px) {
    display: none;
  }
  > ul {
    padding-left: 1.5em;
  }
`;
class Menu extends React.Component {
  render() {
    return (
      <Menustyle>
        <ul>
          <li>
            <Link to="/Kontakt">Kontakt</Link>
          </li>
          {this.props.navPages.map(page => (
            <li>
              <Link to={page.data.slug}>{page.data.title}</Link>
            </li>
          ))}
        </ul>
      </Menustyle>
    );
  }
}

export default withSiteData(siteData => <Menu {...siteData} />);



// WEBPACK FOOTER //
// /opt/build/repo/src/components/menu.js